import Vue from 'vue'
// Moment
import moment from 'moment';
import VueMoment from 'vue-moment';
require('moment/locale/es');
moment.locale('es');

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import VCalendar from 'v-calendar'; // Revisar para package.json
import vSelect from 'vue-select' // Revisar para package.json vue-select@3.10.8
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import VueApexCharts from 'vue-apexcharts'

//import VueCurrencyFilter from 'vue-currency-filter'
//import VuePageTransition from 'vue-page-transition'
import CKEditor from '@ckeditor/ckeditor5-vue2';

//bootstrap, IconsPlugin
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

// Import L&F V2 
import '@/assets/css/L&F/version-two.scss'

//Datatable
import { VuejsDatatableFactory } from 'vuejs-datatable';

//Styles
import '@/assets/scss/app.scss'

// Datepiker 
import VueMonthlyPicker from 'vue-monthly-picker'

import Vuelidate from 'vuelidate'
Vue.use(VueApexCharts)

Vue.use(Vuelidate)

//load axios
Vue.use(VueAxios, axios)

// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

//Use Datatable
Vue.use(VuejsDatatableFactory);

Vue.use(CKEditor);

// Use V-Calendar
Vue.use(VCalendar, {
  componentPrefix: 'vc'  // Use <vc-calendar /> instead of <v-calendar />
  // ...other defaults
});

// Use moment
Vue.use(VueMoment, { moment });

// Use searchable filter select
Vue.component('v-select', vSelect)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.component('vue-monthly-picker', VueMonthlyPicker)

// Elemento de carga de la version 2
import LoaderV2 from '../src/components/common/loaders/LoaderV2.vue'
import LoaderDotsV2 from '../src/components/common/loaders/LoaderDotsV2.vue'
Vue.component('loaderVersion2', LoaderV2)
Vue.component('loaderDotsV2', LoaderDotsV2)

Vue.component('apexchart', VueApexCharts)

// Mixis if using global
import functions from '@/plugins/mixins/functions'
Vue.mixin(functions)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

